export const adobeTags = {
  ON_PAGE_LOAD: (pageData) => {
    return {
      event: 'pageload',
      data: {
        pageName: pageData.pageName,
        siteSectionL1: pageData.section1,
        siteSectionL2: pageData.section2,
        siteSectionL3: pageData.section3,
        siteSectionL4: '',
        siteSectionL5: '',
        website: 'digital security',
        businessUnit: 'uhc',
        referringSite: '',
        loginStatus: 'loggedin',
        language: 'English',
        providerTitle: '',
        providerOrgType: pageData.orgType,
        healthCareOrganization: pageData.organization,
        providerAccountDesc: '',
        providerUuid: pageData.uuid,
        registrationTaxId: pageData.tin,
      },
    };
  },
  FORM_VALIDATION_ERROR: (data) => {
    return {
      event: 'formError',
      data: {
        errorMessage: 'Missing or invalid field(s)',
        errorFields: data.fields.join(','),
        errorType: 'form',
        pageName: data.pageName || '',
      },
    };
  },
  TIN_REGISTRATION_START: (values) => {
    return {
      event: 'jobStartTinRegistration',
      data: {
        jobName: values.jobName,
        orgType: values.orgType,
      },
    };
  },
  TIN_REGISTRATION_COMPLETION: (values) => {
    return {
      event: 'jobCompleteTinRegistration',
      data: {
        jobName: values.jobName,
        orgType: values.orgType,
        jobFunctions: values.jobFunctions,
        portalTaskAccess: values.portalTaskAccess,
        providerUuid: values.providerUuid,
        registrationTaxId: values.registrationTaxId,
        rcmOrBillingFlag: values.rcmOrBillingFlag,
        companyName: values.companyName || 'NA',
      },
    };
  },
  PAA_REGISTRATION_STARTS: (values) => {
    return {
      event: 'jobStartPaaRegistration',
      data: {
        jobName: values.jobName,
      },
    };
  },
  PAA_REGISTRATION_COMPLETION: (values) => {
    return {
      event: 'jobCompletePaaRegistration',
      data: {
        jobName: values.jobName,
        companyVerificationMethod: values.companyVerificationMethod,
        providerUuid: values.providerUuid,
        registrationTaxId: values.registrationTaxId,
      },
    };
  },
  CTA_CLICKS: (values) => {
    return {
      event: 'interaction',
      data: {
        interactionName: values.name,
        interactionValue: values.value,
        interactionContext: values.context,
      },
    };
  },
  DOWNLOAD_CLICKS: (values) => {
    return {
      event: 'download click',
      data: {
        downloadFileName: values.downloadFileName,
        fileUrl: values.fileUrl,
        fileContext: values.fileContext,
      },
    };
  },
  MODAL_OPEN: (values) => {
    return {
      event: 'modal view',
      data: {
        modalName: values.modalName,
      },
    };
  },
  MODAL_CLOSE: (values) => {
    return {
      event: 'modal close',
      data: {
        modalName: values.modalName,
      },
    };
  },
  MAIL_VALIDATION: (values) => {
    return {
      event: 'interaction',
      data: {
        interactionName: values.interactionName,
        interactionValue: values.interactionValue,
        interactionContext: values.interactionContext,
      },
    };
  },

  RCM_SELECTION: (values) => {
    return {
      event: 'interaction',
      data: {
        interactionName: values.interactionName,
        interactionValue: values.interactionValue,
        interactionContext: values.interactionContext,
      },
    };
  },
  API_TRANSACTION_ERROR: (values) => {
    return {
      event: 'siteError',
      data: {
        errorMessage: values.errorMessage,
        errorApiCode: values.errorApiCode,
        errorHttpsCode: values.errorHttpsCode,
        errorType: 'site',
      },
    };
  },
  NEW_TIN_ERROR: (values) => {
    return {
      event: 'siteError',
      data: {
        errorMessage: values.errorMessage,
        errorApiCode: values.errorApiCode,
        errorHttpsCode: values.errorHttpsCode,
        errorType: 'site',
      },
    };
  },
  EXIT_LINK_CLICK: (values) => {
    return {
      event: 'exit click',
      data: {
        exitLink: values.exitLink || '',
        exitURL: values.exitUrl,
      },
    };
  },
  EXIT_CLICK: (values) => {
    return {
      event: 'exit click',
      data: {
        exitLink: values.exitLink,
      },
    };
  },
};
